import { SingleValue } from 'react-select';

import { Stream } from 'types/stream';
import { DataWidgetFiltersInput } from 'dashboards/types/filter';

import { useStreams } from 'streams/hooks/useStreams';

import { StreamSelect } from 'streams/components/StreamSelect/StreamSelect';

import { Placeholder } from './SuggestionInput';
import { filterIds } from '../service';
import { useDataWidgetFiltersInputState } from '../context';

type StreamsFilterInputProps = Pick<DataWidgetFiltersInput, 'id' | 'value'>;

export function StreamFilterInput({ id, value }: StreamsFilterInputProps) {
  const { filters, updateFilter } = useDataWidgetFiltersInputState();

  const sourceIds = filterIds('source_id', filters);

  const { data: streams, isInitialLoading } = useStreams({
    params: { stream_ids: sourceIds, limit: sourceIds.length },
    enabled: Boolean(sourceIds.length),
    keepPreviousData: true,
  });

  if (!streams && isInitialLoading) {
    return Placeholder;
  }

  function handleStreamChange(stream: SingleValue<Stream>) {
    if (!stream) {
      return;
    }

    updateFilter(id, { value: stream.id });
  }

  return (
    <StreamSelect
      queryFilters={{
        stream_types: ['file', 'rtsp'],
        sources: ['camera_stream', 'uri_stream'],
      }}
      defaultValue={streams?.data.find(({ id }) => id === value)}
      onChange={handleStreamChange}
      styles={{
        menu: (provided) => ({
          ...provided,
          width: 'auto',
        }),
      }}
    />
  );
}
